export default {"src":"/_next/static/media/Top.c2e6503d.svg","height":102,"width":1440,"blurWidth":0,"blurHeight":0};